import { useEffect, useState } from 'react'
import { HttpLCLS } from '../api/httpLCLS'
import { QueryStatus } from 'src/types'
import { OperacionLCLSCuentaLimitesAprobadosPais } from '../types/dto'
import { FormFiltros } from '../../../../limites/FiltrosBusqueda'

export const useLimitesLCLS = (filtros: FormFiltros) => {
    const [limites, setLimites] = useState<OperacionLCLSCuentaLimitesAprobadosPais[]>()
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)

    const fetch = () => {
        setStatus(QueryStatus.Loading)

        HttpLCLS.getLimitesAprobados(filtros)
            .then(value => {
                setLimites(value)
                setStatus(QueryStatus.Success)
            })
            .catch(e => {
                setStatus(QueryStatus.Error)
                console.log(e)
            })
    }

    const refetch = () => fetch()

    useEffect(() => {
        fetch()
    }, [filtros])

    return { limites, refetch, status }
}
